import { Injectable } from '@angular/core';
import { interval, map, Observable, startWith, takeWhile } from 'rxjs';

@Injectable()
export class CountdownService {
  constructor() {}

  getCountdown(expireAt: Date): Observable<string> {
    return interval(1000).pipe(
      startWith(0),
      map(() => {
        const now = new Date().getTime();
        const target = new Date(expireAt).getTime();
        const diff = target - now;

        if (diff <= 0) return '';

        const seconds = Math.floor((diff / 1000) % 60);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));

        return `${days} d ${hours}h ${minutes}m ${seconds}s`;
      })
    );
  }
}
